import { inject } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Location } from '@angular/common';
import { UserCommsService } from '../services/user-comms.service';
import { filter } from 'rxjs/operators';

const ORIGINAL_URL = window.location.href;

export function initUserCommsObserver() {  
  const router = inject(Router);
  const userCommsService = inject(UserCommsService);
  const location = inject(Location);


  const parsedUrl = new URL(ORIGINAL_URL);
  const commsId = parsedUrl.searchParams.get('userCommsId');

  if (commsId) {
    const valid = /^[a-zA-Z0-9\-_]+$/.test(commsId);
    if (valid) {
      userCommsService.registerClick(ORIGINAL_URL);
      
      parsedUrl.searchParams.delete('userCommsId');
      const cleanUrl = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
      location.replaceState(cleanUrl);
    }
  }

  router.events.pipe(
    filter(event => event instanceof NavigationStart)
  ).subscribe((event: NavigationStart) => {
    const currentUrl = window.location.origin + event.url;
    const currentParsedUrl = new URL(currentUrl);
    const currentCommsId = currentParsedUrl.searchParams.get('userCommsId');
    
    if (currentCommsId) {
      const valid = /^[a-zA-Z0-9\-_]+$/.test(currentCommsId);
      if (valid) {
        userCommsService.registerClick(currentUrl);
        currentParsedUrl.searchParams.delete('userCommsId');
        location.replaceState(currentParsedUrl.pathname + currentParsedUrl.search);
      }
    }
  });
}